import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
const { Section } = Styles;
export default Section;
